export default __webpack_public_path__ + "static/media/rec_1.ca001292.jpg";